// extracted by mini-css-extract-plugin
export default {"bagLinks":"SZCfhil","mvtBagLinks":"ftULCuG","buttonContainer":"M_NSHty"};